( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '[data-component="project-archive"]' ).forEach( ( archive ) => {
        const filter = archive.querySelector( '.js-project-archive-filter' );
        const cards = archive.querySelectorAll( '.js-project-archive-card' );
        const emptyMessage = archive.querySelector( '.js-project-archive-empty' );

        if ( filter ) {
          filter.addEventListener( 'change', function() {
            const selectedCategory = this.value;
            let visibleCards = 0;

            cards.forEach( ( card ) => {
              const categories = ( card.dataset.projectCategories || '' ).split( ' ' );
              const isVisible = selectedCategory === 'all' || categories.includes( selectedCategory );

              card.classList.toggle( 'hidden', !isVisible );
              card.setAttribute( 'aria-hidden', isVisible ? 'false' : 'true' );

              if ( isVisible ) visibleCards++;
            } );

            if ( emptyMessage ) {
              emptyMessage.classList.toggle( 'hidden', visibleCards > 0 );
            }
          } );
        }
      } );

      document.addEventListener( 'click', function( event ) {
        const thumb = event.target.closest( '[data-project-archive-thumb]' );
        if ( !thumb ) return;

        const parent = thumb.dataset.parent;
        const mainImage = document.getElementById( `project-archive-main-img-${parent}` );

        if ( mainImage && thumb.dataset.src ) {
          mainImage.src = thumb.dataset.src;
        }

        document.querySelectorAll( `[data-project-archive-thumb][data-parent="${parent}"]` ).forEach( ( item ) => {
          item.classList.remove( 'is-active' );
        } );

        thumb.classList.add( 'is-active' );
      } );
    },
  };

  app.registerComponent( 'project-archive', COMPONENT );
} )( app );
